import * as InvoiceModels from '../../models/invoice/invoice';
import * as Models from "../../models/commonModels";

export class Get {
  static readonly type = "[Settings] Get";
  constructor() { }
} 